// This file is auto-generated. DO NOT EDIT THIS FILE MANUALLY!
//
// To regenerate this file, run yarn genDocRefEligibleEntityTypes.
//
// This file is generated from:
// - Static direct/embedded entities in packages/building-types/entities/docRefDirectEligibleEntities.ts
// - Constraint definitions in packages/building-types/doc/docEntityConstraints.ts
import type { DocEntityType } from "building-types/doc/docEntityTypes";

/**
 * Runtime object for ineligible doc ref entity types.
 * This object is the source of truth - types in building-types are derived from it.
 *
 * @see ./DocRefEligibleEntityTypes.md for detailed guidance on how eligibility
 * categories are computed.
 */
export const docRefIneligibleEntities = {
  AUTO_DIMENSION: true,
  DOC_REF: true,
  DORMER: true,
  EDGE: true,
  EDIT_MODE: true,
  ELECTRICAL_DEVICE: true,
  ELECTRICAL_LAYOUT: true,
  ELEVATION_VIEW: true,
  FLOOR_BAY: true,
  FLOOR_PERIMETER_OPENING: true,
  FLOOR_SPLIT_LINE: true,
  FREEFORM_WALL: true,
  GENERATED_ENTITY: true,
  INDETERMINATE_ENTITY_TYPE: true,
  MEASUREMENT: true,
  OPTION_TEMPLATE: true,
  PLAN_VIEW: true,
  RAILING_POST: true,
  REFERENCE_GEOM: true,
  ROOF_VOLUME: true,
  SECTION_VIEW: true,
  SELECTOR: true,
  SHAPE: true,
  SYSTEM_PARAMETER: true,
  VERTEX: true,
  VIEW_OVERRIDE: true,
  VIEW_SELECTOR: true,
  WALL_PLANE_RULE: true,
  WALL_PLANE_TRIM: true,
} as const satisfies Partial<Record<DocEntityType, true>>;

// This file is auto-generated. DO NOT EDIT THIS FILE MANUALLY!
//
// To regenerate this file, run yarn genDocRefEligibleEntityTypes.
//
// This file is generated from:
// - Static direct/embedded entities in packages/building-types/entities/docRefDirectEligibleEntities.ts
// - Constraint definitions in packages/building-types/doc/docEntityConstraints.ts
